import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import { SharedModalActions } from 'reactApp/modules/sharedModal/sharedModal.module';
import { SharedModalSelectors } from 'reactApp/modules/sharedModal/sharedModal.selectors';

export function useWeblinkOpened(from: EFrom, isPublished: boolean) {
    const dispatch = useDispatch();

    const isWeblinkOpened = useSelector(SharedModalSelectors.isWeblinkOpened);
    const [isWeblinkInfoLoading, setIsWeblinkInfoLoading] = useState(true);

    useEffect(() => {
        dispatch(SharedModalActions.setWeblinkOpened({ opened: from === EFrom.WEBLINK || isPublished }));
        setIsWeblinkInfoLoading(false);

        return () => {
            dispatch(SharedModalActions.setWeblinkOpened({ opened: false }));
        };
    }, []);

    const setWeblinkOpened = useCallback((opened: boolean) => {
        dispatch(SharedModalActions.setWeblinkOpened({ opened }));
    }, []);

    return { isWeblinkOpened, setWeblinkOpened, isWeblinkInfoLoading };
}
